import { ReactNode } from "react";

export const TableTooltipLabel = ({
  ariaLabel,
  label,
  tooltip,
}: {
  ariaLabel?: string;
  label: ReactNode;
  tooltip: string;
}) => (
  <span
    className="table-tooltip-label"
    aria-label={ariaLabel ?? (typeof label === "string" ? label : undefined)}
    data-tooltip-id="global-tip"
    data-tooltip-html={tooltip}>
    {label}
  </span>
);
